/* eslint-disable no-undef */
import { call, put, takeEvery } from "redux-saga/effects"

// Login Redux States
import { ADD_SUPPORT_MATERIAL } from "./actionTypes"
import { apiError, addSupportMaterialSuccess } from "./actions"

//Include Both Helper File with needed methods
import { addSupportMaterial } from "../../../helpers/backend_helper"

function* add(action) {
  try {
    const response = yield call(addSupportMaterial, action.payload)
    if (response === undefined) throw new Error("API error")
    else yield put(addSupportMaterialSuccess(response))
  } catch (error) {
    yield put(apiError(error.message))
  }
}

function* supportMaterialAddSaga() {
  yield takeEvery(ADD_SUPPORT_MATERIAL, add)
}

export default supportMaterialAddSaga
